package com.nonopn.skywatcher.common.login

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.ILoginCaller
import com.nonopn.skywatcher.common.homepage.HomepageScreen
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.blipya.common_sub_login.generated.resources.Res
import eu.codlab.blipya.common_sub_login.generated.resources.app_sub_title
import eu.codlab.blipya.common_sub_login.generated.resources.login_account_title
import eu.codlab.compose.widgets.StatusBarAndNavigation
import eu.codlab.compose.widgets.preview.PreviewDarkLightColumn
import org.jetbrains.compose.resources.StringResource

@Composable
fun SessionScreen(
    modifier: Modifier = Modifier,
    appMainTitle: StringResource,
    loginTitle: StringResource,
    loginCaller: ILoginCaller,
    defaultWidth: Dp = 0.dp
) {
    StatusBarAndNavigation()

    Column(
        modifier.background(Color.Transparent),
        Arrangement.spacedBy(5.dp)
    ) {
        HomepageScreen(
            modifier = Modifier.align(Alignment.CenterHorizontally),
            defaultWidth
        ) {
            OpenSessionContent(
                appMainTitle,
                loginTitle,
                loginCaller
            )
        }
    }
}

@HotPreview(widthDp = 500, heightDp = 360, darkMode = true)
@HotPreview(widthDp = 500, heightDp = 360, darkMode = false)
@HotPreview(widthDp = 360, heightDp = 500, darkMode = true)
@HotPreview(widthDp = 360, heightDp = 500, darkMode = false)
@Composable
fun SessionScreenDisplayPreviewDark() {
    PreviewDarkLightColumn(submodifier = { Modifier.height(200.dp) }) { modifier, _ ->
        SessionScreen(
            appMainTitle = Res.string.app_sub_title,
            loginTitle = Res.string.login_account_title,
            loginCaller = object : ILoginCaller {
                override fun register(
                    email: String,
                    password: String,
                    callback: (err: Throwable?) -> Unit
                ) = Unit

                override fun login(
                    email: String,
                    password: String,
                    callback: (err: Throwable?) -> Unit
                ) = Unit
            },
            defaultWidth = 360.dp,
            modifier = modifier
        )
    }
}
